import { DetalleResumenPropuesta } from './detalleResumenProp';
import { ResumenPropuestaSeccion } from './resumenPropuestaSeccion';

export class ResumenPropuesta {

    resumen : DetalleResumenPropuesta;
    detalleSeccion : ResumenPropuestaSeccion[];
}